enum OrderEnum {
    asc = <any>"ascending",
    desc = <any>"descending",
}

export default OrderEnum
